// extracted by mini-css-extract-plugin
export default {"SidebarSectionContainer":"SidebarSection_SidebarSectionContainer__7hy5M"};